import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NewsList from './news_list';
import NewsDetail from './news_detail';

class News extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <NewsList/>;
    }else{
      if(params.id===undefined){
        view = <NewsDetail/>;
      }else{
        view = <NewsDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

News.contextTypes = {
  router: PropTypes.object
};

export default News;
